const mlIN= {
    login: {
      title: 'സൈൻ ഇൻ ചെയ്യുക',
      sign_in_btn: 'സൈൻ ഇൻ ചെയ്യുക'
    },
    bar: {
        logout: 'ലോഗൗട്ട് ചെയ്യുക',
        languages: 'ഭാഷകൾ',
        settings: 'ക്രമീകരണം തുറക്കുക'
    },
    language: {
      name: 'മലയാളം (ഇന്ത്യ)',
    },
    attributePage: {
        title: 'ആട്രിബ്യൂട്ടുകളിലെ മാറ്റങ്ങൾ',
        viewChanges: 'മാറ്റങ്ങൾ കാണുക',
        dateTime: 'തീയതി',
        notificationType: 'അറിയിപ്പ് തരം',
        notificationValue: 'അറിയിപ്പ് മൂല്യം',
        oldValue: 'പഴയ മൂല്യം',
        newValue: 'പുതിയ മൂല്യം',
        accept: 'അംഗീകരിക്കുക',
        reject: 'നിരസിക്കുക',
    },
    Home: 'ഹോം',
    load: 'പ്രാരംഭ ലോഡ് ചെയ്യൽ നടത്തുന്നു...',
    Requested: "അഭ്യർത്ഥിച്ചു",
    Viewed: "കണ്ടു",
    Executing: "നടപ്പാക്കുന്നു",
    Completed: "പൂർത്തിയായി",
    Expired: "കാലഹരണപ്പെട്ടു",
    Cancelled: "റദ്ദാക്കി",
    Error: "പിശക്",
    Rejected: "നിരസിച്ചു",
    error: 'എന്തോ കുഴപ്പം സംഭവിച്ചു; പിന്നീട് വീണ്ടും ശ്രമിക്കുക.',
    displayname: 'പ്രദർശന നാമം',
    givenname: 'പേര്',
    surname: 'സർനെയിം',
    email: 'ഇമെയിൽ',
    mail: 'ഇമെയിൽ',
    name: 'പേര്',
    firstname: 'പേര്',
    lastname: 'സർനെയിം',
    footer_copyright: 'എല്ലാ അവകാശങ്ങളും പരിരക്ഷിതം.'
  };
  
  export default mlIN;
  